import { render, staticRenderFns } from "./DefaultOrderStatus.vue?vue&type=template&id=f31e2e54&scoped=true&"
import script from "./DefaultOrderStatus.vue?vue&type=script&lang=js&"
export * from "./DefaultOrderStatus.vue?vue&type=script&lang=js&"
import style0 from "./DefaultOrderStatus.vue?vue&type=style&index=0&id=f31e2e54&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f31e2e54",
  null
  
)

export default component.exports